export default function preprocess(requestInfo, preprocessFunc, prevData) {
    return preprocessFunc(requestInfo, prevData);
}
